import React from 'react';

export const InvestorTagIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 12.7073V4.48622C12 4.15737 11.8576 3.82853 11.5778 3.57733L8.01729 0.380227C7.4527 -0.126742 6.5473 -0.126742 5.98271 0.380227L2.42218 3.57733C2.14242 3.82853 2 4.15737 2.00509 4.49079L2 12.7073C2.00509 13.0408 2.14242 13.3742 2.42218 13.6254C2.70193 13.8766 3.07324 13.9999 3.43947 13.9999H10.5605C10.9318 14.0044 11.2981 13.8766 11.5778 13.6254C11.8627 13.3696 12 13.0362 12 12.7073ZM8 3C8 3.55228 7.55228 4 7 4C6.44772 4 6 3.55228 6 3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3ZM8.5 7.5C8.5 8.32875 7.82875 9 7 9C6.17125 9 5.5 8.32875 5.5 7.5C5.5 6.67125 6.17125 6 7 6C7.82875 6 8.5 6.67125 8.5 7.5ZM4 11.25C4 10.2525 5.99875 9.75 7 9.75C8.00125 9.75 10 10.2525 10 11.25V12H4V11.25Z"
      fill="#757575"
    />
  </svg>
);
